import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

require('@/styles/frame.scss')
require('@/styles/global.scss')

createApp(App).use(store).use(router).mount('#app')
